import Bluebird from 'bluebird';
import { getBrowserLanguage, getLocalItem, setLocalItem } from './browser-storage';
import getCountry from './geolocate';
import { isCountryCode } from './resources';

let countryCache: string | null = null;

const defaults = {
    locale: 'en',
    country: 'GB'
};

export default function getCountryCode(): Bluebird<string> {
    if (countryCache) return Bluebird.resolve(countryCache);

    return getCountry().then(
        code => code || getCountryFromLanguage(),
        () => getCountryFromLanguage()
    )
        .catch(() => defaults.country)
        .then(code => {
            if (code) setLocalItem('country', code);
            return countryCache = code;
        });
}

function getCountryFromLanguage(): Bluebird<string> {
    let language = getBrowserLanguage();

    if (language) {
        do {
            const i = language.indexOf('-');
            if (i >= 0) language = language.slice(i + 1);
        } while (language.indexOf('-') >= 0);
    }

    if (!language) {
        return Bluebird.reject(new Error('Language is not defined'));
    }

    return isCountryCode(language.toUpperCase())
        .then(isValid => {
            if (isValid && language) return language;
            throw new Error('Not a valid country code');
        });
}

export function loadCountryCode(): Bluebird<any> {
    // Load cached country code from localstorage
    const country = getLocalItem('country');
    if (!country) return Bluebird.resolve();

    countryCache = country;
    return isCountryCode(country).then(valid => {
        if (!valid) countryCache = null;
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/country-code.ts